<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        Dashboard</router-link
      ><i class="fa fa-ellipsis-v text-white"></i>
      <router-link to="/student/exam" class="text-white">
        CBT
      </router-link>
      <span class="text-white"
        ><i class="fa fa-ellipsis-v"></i>CBT Result Details
      </span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body">
              <div v-html="resultItems"></div>   
               <hr/>
              <div class="text-center" v-if="resultItems">
                <router-link to="/studentcbtexam" class="btn btn-success"
              > TAKE NEW TEST <i class="fa fa-arrow-right"></i> </router-link
            >
              </div>           
            </div>
          </div>
        </card>
      </div>

      <!-- End charts-->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import PageSpinner from "@/components/PageSpinner"
export default {
  name: "exam",
  components: {
    PageSpinner
  },
  data() {
    return {
      accessDetails: null,
      dataid: 1,
      ExamCodeval: localStorage.getItem("ExamCode") || "",
      resultItems:null,     
      onloader: "none",
    };
  },
  methods: {    
    getresultdetails: function () {    
        if(this.ExamCodeval==null){
            this.$router.push("/cbtprep");
        }else{
            let ExamCode = this.ExamCodeval;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userData = {        
                ExamCode,
                username,
                accesskey,
            };

            this.onloader = "flex";
            this.$store
                .dispatch("getresultdetails", userData)
                .then((resp) => {
                    this.resultItems = resp;          
                    this.onloader = "none";
                })
                .catch(() => {
                    this.onloader = "none";
                    this.$router.push("/cbtprep");
                });
        }      
    },
    
    frontEndDateFormat: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },   
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];
    if (this.accessDetails.isSchoolStudent == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    } else {
      this.getresultdetails();
    } 
  },
};
</script>

<style></style>
